module.exports = __webpack_public_path__ + "static/blue_slaad-6539039e5cbffc220dec7a86cfb7867f.jpeg";